// Verbatim from TamCentralStation src/services/EventHistoryService.js.
// eventId alone is NOT unique in getEventReport data; use the composite key.
export function eventKey(e) {
    return `${e.eventId || ''}|${e.eventType || ''}|${e.visitId || ''}|${e.vehicleNumber || ''}|${e.timestamp || ''}`;
}
// One physical gate transaction (combined tractor+trailer scans share type+timestamp).
export function gateTxnKey(e) {
    return `${e.eventType || ''}|${e.timestamp || ''}`;
}
